export default "__VITE_ASSET__DbyfdeUG__"